import React from 'react';
import { Link } from 'react-router-dom';
import { Wind, Sun, Wrench, ClipboardList, Truck, Headphones } from 'lucide-react';

const SERVICOS = [
  {
    icon: Wind,
    title: 'Ar condicionado',
    description: 'Instalação, manutenção e assistência técnica de ar condicionado para sua casa ou negócio.',
    href: '/ar-condicionado',
  },
  {
    icon: Sun,
    title: 'Painéis solares',
    description: 'Painéis solares térmicos e fotovoltaicos para poupança energética e sustentabilidade.',
    href: '/paineis-solares',
    id: 'card-paineis-solares',
  },
  {
    icon: Wrench,
    title: 'Assistência técnica',
    description: 'Manutenção e reparação com equipas qualificadas e peças das melhores marcas.',
    href: null,
  },
];

const PILARES = [
  { icon: ClipboardList, label: 'Planeamento' },
  { icon: Truck, label: 'Instalação' },
  { icon: Headphones, label: 'Assistência Técnica' },
];

export default function SiteServicos() {
  return (
    <section id="servicos" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Serviços
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Soluções eficazes e funcionais para o seu conforto e bem-estar.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {SERVICOS.map(({ icon: Icon, title, description, href, id }) => {
            const cardContent = (
              <>
                <div className="w-14 h-14 bg-gestao-primary rounded-xl flex items-center justify-center text-white mb-6">
                  <Icon size={28} />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{title}</h3>
                <p className="text-slate-600">{description}</p>
              </>
            );
            const cardClassName = 'p-8 rounded-2xl bg-gestao-background border border-slate-200 hover:border-gestao-primary/30 transition-colors block';
            if (href) {
              return (
                <Link
                  key={title}
                  {...(id ? { id } : {})}
                  to={href}
                  className={cardClassName}
                  style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
                  aria-label={`${title} – ir para a página`}
                >
                  {cardContent}
                </Link>
              );
            }
            return (
              <div
                key={title}
                className="p-8 rounded-2xl bg-gestao-background border border-slate-200 hover:border-gestao-primary/30 transition-colors"
              >
                {cardContent}
              </div>
            );
          })}
        </div>

        <div className="flex flex-wrap justify-center gap-8 sm:gap-12">
          {PILARES.map(({ icon: Icon, label }) => (
            <div key={label} className="flex flex-col items-center gap-3">
              <div className="w-12 h-12 bg-gestao-primary/10 rounded-full flex items-center justify-center text-gestao-primary">
                <Icon size={22} />
              </div>
              <span className="font-semibold text-slate-800">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
